import { Button, Col, Form, Row, Space, Switch } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { ExtraTabsWrapper } from "../../pages/cms/cpd/tabs";

const PageListActionBar = ({
  leftElement: LeftComponent = () => null,
  rightElement: RightComponent = () => null,
}) => {
  return (
    <Form
      layout="vertical"
      style={{
        marginBottom: 24,
        background: "#fafafa",
        padding: 8,
        borderRadius: 8,
      }}
    >
      <Row gutter={16} align="middle">
        <Col span={12}>
          {/* Left */}
          <LeftComponent />
        </Col>
        <Col
          span={12}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "end",
          }}
        >
          {/* Right: Add Action, View Controls */}
          <RightComponent />
        </Col>
      </Row>
    </Form>
  );
};

export const PageListActionBarTitles = ({ tabs }) => (
  <Space className="flex items-center gap-2 mb-4 flex-wrap">
    {tabs?.map((tab) => (
      <Button
        key={tab?.key}
        icon={tab?.icon}
        className="rounded-full border border-gray-300 bg-white px-3"
        type="text"
        color="default"
        variant="text"
      >
        {tab?.label}
      </Button>
    ))}
  </Space>
);

export const ExtraTabsContent = ({
  buttonText,
  setIsDrawerOpen,
  setIsPreviewOn,
  isPreviewOn,
  disabled,
  children,
}) => {
  switch (buttonText) {
    case "Resource":
      return (
        <ExtraTabsWrapper>
          {children}
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setIsDrawerOpen(true)}
          >
            {`Add ${buttonText}`}
          </Button>
        </ExtraTabsWrapper>
      );
    case "Case":
    case "Question":
      return (
        <ExtraTabsWrapper>
          {children}
          <Switch
            checkedChildren="Editing"
            unCheckedChildren="Default"
            value={isPreviewOn}
            disabled={disabled}
            onChange={(checked) => setIsPreviewOn(checked)}
          />
        </ExtraTabsWrapper>
      );
    default:
      return (
        <ExtraTabsWrapper>
          {children}
          <Switch
            checkedChildren="Editing"
            unCheckedChildren="Default"
            value={isPreviewOn}
            disabled={disabled}
            onChange={(checked) => setIsPreviewOn(checked)}
          />
        </ExtraTabsWrapper>
      );
  }
};

export default PageListActionBar;
